import React from 'react'
import Select, { createFilter } from 'react-select'
import BaseField from 'components/form/BaseField'

const stringify = option => {
	return `${option.data.name} ${option.data.abbreviature}`
}

export const CustomSelectField = ({ input: { value, name, placeholder, onChange, onBlur }, className, optionComponent, SingleValue, options, ...rest }) => {
	return <BaseField {...rest}>
		<Select
			value={value}
			name={name}
			placeholder={placeholder}
			onChange={selected => onChange(selected)}
			onBlur={() => {}}
			className={'c-select ' + className}
			classNamePrefix='c-select'
			isSearchable
			filterOption={createFilter({ ignoreCase: true, stringify })}
			options={options}
			components={{
				Option: optionComponent,
				SingleValue
			}}
			onBlurResetsInput={false}
			{...rest}
		/>
	</BaseField>
}

export default CustomSelectField
